
import { mapGetters } from 'vuex'
export default {
    props: {
        item: {
            type: Object,
            default: () => { }
        }
    },
    data () {
        return {}
    },
    computed: {
        ...mapGetters({
            userinfo: 'user/userinfo',
        })
    },
    mounted () { },
    methods: {
        async onBuy () {
            await this.$store.dispatch('user/UserGetInfo')
            if(!this.userinfo.isRealName){
                this.$message.warning('未实名用户不可交易，请先完成实名认证')
                return
            }
            // 先判断有没有实名认证
            const { fictitiousOrderId } = this.item.content.content
            const par = {
                fictitiousOrderId
            }
            // 判断商品状态
            const res = await this.$api.checkOrderStatusByFictitiousOrderId(par)
            if (!res.success) {
                return this.$message.error(res.info)
            }
            const query = {
                goodsNo: this.item.content.content.goodsNo,
                goodsCatalogueId: this.item.content.content.goodsCatalogueId || 6,
                orderType: 'fictitiousOrder',
                status: 'null',
                fictitiousOrderId: this.item.content.content.fictitiousOrderId,
                fictitiousOrderPrice: this.item.content.content.modifyPrice
            }
            // success:true 就让它通过
            this.$router.push({
                path: '/confirmOrder/fullPayment',
                query
            })
        }
    }
}
